import { createRouter, createWebHistory } from "vue-router";
import SideMenu from "../layouts/side-menu/Main.vue";
import SimpleMenu from "../layouts/simple-menu/Main.vue";
import TopMenu from "../layouts/top-menu/Main.vue";
import Login from "../views/login/Main.vue";
import CheckAdmin from "../views/login/CheckAdmin.vue";
import Register from "../views/register/Main.vue";
import ErrorPage from "../views/error-page/Main.vue";

import LabAnalysisList from "../views/lab-analysis/Main.vue";
import LabAnalysisEdit from "../views/lab-analysis/Edit.vue";

import FoodList from "../views/food/Main.vue";
import FoodListByUser from "../views/food/ListByUser.vue";
import Food from "../views/food/Edit.vue";
import FoodEdit from "../views/food/Edit-2.vue";

import SupplementList from "../views/supplements/Main.vue";
import Supplement from "../views/supplements/Edit.vue";
import SupplementMarcaList from "../views/supplements/marcas/Main.vue";
import SupplementMarca from "../views/supplements/marcas/Edit.vue";
import SupplementProductList from "../views/supplements/productos/Main.vue";
import SupplementProduct from "../views/supplements/productos/Edit.vue";

// Benefits of a Supplement
import SupplementBenefitsList from "../views/supplements/benefits/List.vue";
import SupplementBenefitsNew from "../views/supplements/benefits/New.vue";

// Platforms of a Science Source
import ScienceSourcePlatformsList from "../views/science-source/platforms/List.vue";
import ScienceSourcePlatformsNew from "../views/science-source/platforms/New.vue";

// Problems of a Supplement
import SupplementProblemsList from "../views/supplements/problems/List.vue";
import SupplementProblemsNew from "../views/supplements/problems/New.vue";

// Purposes of a Supplement ("Sirve para")
import SupplementPurposesList from "../views/supplements/purposes/List.vue";
import SupplementPurposesNew from "../views/supplements/purposes/New.vue";

import MedicationList from "../views/medication/Main.vue";
import MedicationEdit from "../views/medication/Edit.vue";
import MedicationFamilyList from "../views/medication/family/Main.vue";
import MedicationFamilyEdit from "../views/medication/family/Edit.vue";

import DiseaseList from "../views/disease/Main.vue";
import DiseaseEdit from "../views/disease/Edit.vue";

import SessionsList from "../views/recommendations-comparison/Sessions-list.vue";
import RecommendationComparison from "../views/recommendations-comparison/Recommendation-comparison.vue";

import ReceipesList from "../views/receipes/Main.vue";
import Receipe from "../views/receipes/Edit.vue";
import ReceipesListByUser from "../views/receipes/MainByUser.vue";

import ActivitiesList from "../views/activities/Main.vue";
import Activity from "../views/activities/Edit.vue";

import AIInput from "../views/ai/Input.vue";

import Cycle from "../views/cycle/Main.vue";

import Users from "../views/users/Main.vue";
import UsersResults from "../views/users/Results.vue";

import GlossaryList from "../views/glossary/Main.vue";
import Glossary from "../views/glossary/Edit.vue";

import MiniguidesList from "../views/miniguides/Main.vue";
import Miniguide from "../views/miniguides/Edit.vue";

// Ilongame components
import QuestionAndAnswersList from "../views/ilongame/questionWithAnswers/List.vue";
import QuestionAndAnswersNew from "../views/ilongame/questionWithAnswers/New.vue";

// Alerts components
import AlertsList from "../views/alerts/List.vue";
import AlertsNew from "../views/alerts/New.vue";

import { TokenService, Recipes } from "../services/storage.service";

import { useStore } from "@/store";

const routes = [
  {
    path: "/",
    component: SideMenu,
    children: [
      {
        path: "/",
        redirect: (to) => {
          const isAdmin = "isAdmin"; // TokenService.isAdmin()
          if (!isAdmin) {
            return "/miniguides";
          } else {
            return "/lab-analysis-list";
          }
        },
      },
    ],
  },
  {
    path: "/check",
    name: "check-admin",
    component: CheckAdmin,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage,
  },
  {
    path: "/:pathMatch(.*)*",
    component: ErrorPage,
  },
  {
    path: "/lab-analysis-list",
    component: SideMenu,
    children: [
      {
        path: "/lab-analysis-list",
        name: "lab-analysis-list",
        component: LabAnalysisList,
      },
      {
        path: "/lab-analaysis-edit",
        name: "lab-analaysis-edit",
        component: LabAnalysisEdit,
      },
    ],
  },
  {
    path: "/science-platform",
    component: SideMenu,
    children: [
      // Science Platforms of a Supplement
      {
        path: "/science-source-platforms-list",
        name: "science-source-platforms-list",
        component: ScienceSourcePlatformsList,
      },
      {
        path: "/science-source-platforms-new",
        name: "science-source-platforms-new",
        component: ScienceSourcePlatformsNew,
      },
      {
        path: "/science-source-platforms-edit",
        name: "science-source-platforms-edit",
        component: ScienceSourcePlatformsNew,
      },
    ],
  },
  {
    path: "/food",
    component: SideMenu,
    children: [
      {
        path: "/food-list",
        name: "food-list",
        component: FoodList,
      },
      {
        path: "/food-list-by-user",
        name: "food-list-by-user",
        component: FoodListByUser,
      },
      {
        path: "/food-edit",
        name: "food-edit",
        component: Food,
      },
      {
        path: "/food-new",
        name: "food-new",
        component: Food,
      },
      {
        path: "/food-edit-2",
        name: "food-edit-2",
        component: FoodEdit,
      },
    ],
  },
  {
    path: "/supplement",
    component: SideMenu,
    children: [
      {
        path: "/supplement-list",
        name: "supplement-list",
        component: SupplementList,
      },
      {
        path: "/supplement-edit",
        name: "supplement-edit",
        component: Supplement,
      },
      {
        path: "/supplement-new",
        name: "supplement-new",
        component: Supplement,
      },
      {
        path: "/supplement-marcas-list",
        name: "supplement-marcas-list",
        component: SupplementMarcaList,
      },
      {
        path: "/supplement-marcas-new",
        name: "supplement-marcas-new",
        component: SupplementMarca,
      },
      {
        path: "/supplement-marcas-edit",
        name: "supplement-marcas-edit",
        component: SupplementMarca,
      },
      {
        path: "/supplement-productos-list",
        name: "supplement-productos-list",
        component: SupplementProductList,
      },
      {
        path: "/supplement-productos-new",
        name: "supplement-productos-new",
        component: SupplementProduct,
      },
      {
        path: "/supplement-productos-edit",
        name: "supplement-productos-edit",
        component: SupplementProduct,
      },

      // Benefits of a Supplement
      {
        path: "/supplement-benefits-list",
        name: "supplement-benefits-list",
        component: SupplementBenefitsList,
      },
      {
        path: "/supplement-benefits-new",
        name: "supplement-benefits-new",
        component: SupplementBenefitsNew,
      },
      {
        path: "/supplement-benefits-edit",
        name: "supplement-benefits-edit",
        component: SupplementBenefitsNew,
      },

      // Problems of a Supplement
      {
        path: "/supplement-problems-list",
        name: "supplement-problems-list",
        component: SupplementProblemsList,
      },
      {
        path: "/supplement-problems-new",
        name: "supplement-problems-new",
        component: SupplementProblemsNew,
      },
      {
        path: "/supplement-problems-edit",
        name: "supplement-problems-edit",
        component: SupplementProblemsNew,
      },

      // Purposes of a Supplement ("Sirve para")
      {
        path: "/supplement-purposes-list",
        name: "supplement-purposes-list",
        component: SupplementPurposesList,
      },
      {
        path: "/supplement-purposes-new",
        name: "supplement-purposes-new",
        component: SupplementPurposesNew,
      },
      {
        path: "/supplement-purposes-edit",
        name: "supplement-purposes-edit",
        component: SupplementPurposesNew,
      },
    ],
  },
  {
    path: "/medication",
    component: SideMenu,
    children: [
      {
        path: "/medication-list",
        name: "medication-list",
        component: MedicationList,
      },
      {
        path: "/medication-new",
        name: "medication-new",
        component: MedicationEdit,
      },
      {
        path: "/medication-edit",
        name: "medication-edit",
        component: MedicationEdit,
      },
      {
        path: "/medication-family-list",
        name: "medication-family-list",
        component: MedicationFamilyList,
      },
      {
        path: "/medication-family-new",
        name: "medication-family-new",
        component: MedicationFamilyEdit,
      },
      {
        path: "/medication-family-edit",
        name: "medication-family-edit",
        component: MedicationFamilyEdit,
      },
    ],
  },
  {
    path: "/disease",
    component: SideMenu,
    children: [
      {
        path: "/disease-list",
        name: "disease-list",
        component: DiseaseList,
      },
      {
        path: "/disease-edit",
        name: "disease-edit",
        component: DiseaseEdit,
      },
      {
        path: "/disease-new",
        name: "disease-new",
        component: DiseaseEdit,
      },
    ],
  },
  {
    path: "/sessions",
    component: SideMenu,
    children: [
      {
        path: "/sessions-list",
        name: "sessions-list",
        component: SessionsList,
      },
      {
        path: "/recommendation-comparison",
        name: "recommendation-comparison",
        component: RecommendationComparison,
      },
      {
        path: "/user-results",
        name: "user-results",
        component: UsersResults,
      },
    ],
  },
  {
    path: "/receipes",
    component: SideMenu,
    children: [
      {
        path: "/receipes-list",
        name: "receipes-list",
        component: ReceipesList,
      },
      {
        path: "/receipes-list-by-user",
        name: "receipes-list-by-user",
        component: ReceipesListByUser,
      },
      {
        path: "/receipe-edit",
        name: "receipe-edit",
        component: Receipe,
      },
      {
        path: "/receipe-new",
        name: "receipe-new",
        component: Receipe,
      },
    ],
  },
  {
    path: "/miniguides",
    component: SideMenu,
    children: [
      {
        path: "/miniguides-list",
        name: "miniguides-list",
        component: MiniguidesList,
      },
      {
        path: "/miniguide-edit",
        name: "miniguide-edit",
        component: Miniguide,
      },
      {
        path: "/miniguide-new",
        name: "miniguide-new",
        component: Miniguide,
      },
    ],
  },
  {
    path: "/ilongame",
    component: SideMenu,
    children: [
      {
        path: "/question-with-answers-list",
        name: "ilongame-list",
        component: QuestionAndAnswersList,
      },
      {
        path: "/question-with-answers-edit",
        name: "ilongame-edit",
        component: QuestionAndAnswersNew,
      },
      {
        path: "/question-with-answers-new",
        name: "ilongame-new",
        component: QuestionAndAnswersNew,
      },
    ],
  },
  {
    path: "/glossary",
    component: SideMenu,
    children: [
      {
        path: "/glossary-list",
        name: "glossary-list",
        component: GlossaryList,
      },
      {
        path: "/glossary-edit",
        name: "glossary-edit",
        component: Glossary,
      },
      {
        path: "/glossary-new",
        name: "glossary-new",
        component: Glossary,
      },
    ],
  },
  {
    path: "/alerts",
    component: SideMenu,
    children: [
      {
        path: "/alerts-list",
        name: "alerts-list",
        component: AlertsList,
      },
      {
        path: "/alerts-edit",
        name: "alerts-edit",
        component: AlertsNew,
      },
      {
        path: "/alerts-new",
        name: "alerts-new",
        component: AlertsNew,
      },
    ],
  },
  {
    component: SideMenu,
    children: [
      {
        path: "/ai-input",
        name: "ai-input",
        component: AIInput,
      },
    ],
  },
  {
    path: "/cycle",
    component: SideMenu,
    children: [
      {
        path: "/cycle",
        name: "cycle",
        component: Cycle,
      },
    ],
  },
  {
    path: "/activities",
    component: SideMenu,
    children: [
      {
        path: "/activities-list",
        name: "activities-list",
        component: ActivitiesList,
      },
      {
        path: "/activity-edit",
        name: "activity-edit",
        component: Activity,
      },
      {
        path: "/activity-new",
        name: "activity-new",
        component: Activity,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const isAdmin = TokenService.isAdmin();
  const isVerify = TokenService.isVerify();
  const isLocal = TokenService.isLocal();

  const recipeIsSaving = Recipes.isSaving();
  const store = useStore();

  if (
    ((from.path == "/receipe-new" && to.path != "/receipe-new") ||
      (from.path == "/receipe-edit" && to.path != "/receipe-edit")) &&
    recipeIsSaving
  ) {
    store.dispatch("main/setShowWarningSave", to.path);
    return next({
      path: from.path,
    });
  }

  if (to.path == "/check") {
    // t when it comes from redirect console.
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("t")) {
      localStorage.token = urlParams.get("t");
    }
  }

  if ((!isAdmin || !isVerify) && to.path != "/check" && !isLocal) {
    return next({
      path: "/check",
      query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
    });
  }

  if (isAdmin && isVerify && (to.path == "/check" || to.path == "/")) {
    var permissions = localStorage.backoffice_permissions ? JSON.parse(localStorage.backoffice_permissions) : [];
    var key = permissions.length > 0 ? permissions[0] : null;

    var paths = {
      LAB: "/lab-analysis-list",
      FOOD: "/food-list",
      RECIPES: "/receipes-list",
      SUPPLEMENTS: "/supplement-list",
      ILONGAME_QUESTION_WITH_ANSWERS: "/question-with-answers-list",
      ACTIVITIES: "/activities",
      SESSIONS: "/sessions-list",
      AI: "/ai-input",
    };

    var path = key && key.name && paths[key.name] ? paths[key.name] : permissions.length === 0 ? "/food-list" : null;

    if (path === null) {
      localStorage.clear();
      window.location.href = process.env.VUE_APP_CLIENT_URL;
    }

    return next({
      path: path,
    });
  }

  next();
});

export default router;
